import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/** UI display format for dates across the app (dayjs / MUI). */
export const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";

/** Same display format for react-datepicker (different token casing). */
export const REACT_DATEPICKER_DISPLAY_FORMAT = "dd/MM/yyyy";

/** Canonical date string used in form state / API payloads. */
export const API_DATE_FORMAT = "YYYY-MM-DD";

const PARSE_FORMATS = [
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  "YYYY/MM/DD",
  "DD MMM YYYY",
  "D MMM YYYY",
];

/**
 * Parse common API / UI date values into a dayjs instance.
 * Returns null when empty or unparseable.
 */
export const parseToDayjs = (value) => {
  if (value == null || value === "") return null;
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
  if (value instanceof Date) {
    const d = dayjs(value);
    return d.isValid() ? d : null;
  }

  const str = String(value).trim();
  if (!str) return null;

  // Prefer calendar date portion to avoid UTC→local day shifts on timestamps
  const dateOnlyMatch = str.match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateOnlyMatch) {
    const d = dayjs(dateOnlyMatch[1], "YYYY-MM-DD", true);
    if (d.isValid()) return d;
  }

  const iso = dayjs(str);
  if (iso.isValid()) return iso;

  for (const format of PARSE_FORMATS) {
    const d = dayjs(str, format, true);
    if (d.isValid()) return d;
  }
  return null;
};

/**
 * Format a date for on-screen display only (DD/MM/YYYY).
 * Empty input → empty string. Invalid → original string (caller can override empty label).
 */
export const formatDateForDisplay = (value) => {
  if (value == null || value === "") return "";
  const d = parseToDayjs(value);
  if (!d) return String(value);
  return d.format(DISPLAY_DATE_FORMAT);
};

/** Convert any supported date value to YYYY-MM-DD for payloads / form state. */
export const toApiDateString = (value) => {
  if (value == null || value === "") return "";
  const d = parseToDayjs(value);
  if (!d) return "";
  return d.format(API_DATE_FORMAT);
};
